/**
 * @generated SignedSource<<5a280a219d29badbfb8495adefa52492>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useAddItemToCart_item$data = {
  readonly defaultSkuId: string;
  readonly serviceId: string | null;
  readonly " $fragmentType": "useAddItemToCart_item";
};
export type useAddItemToCart_item$key = {
  readonly " $data"?: useAddItemToCart_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useAddItemToCart_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useAddItemToCart_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "defaultSkuId",
        "storageKey": null
      },
      "action": "THROW",
      "path": "defaultSkuId"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "bbac6f343bc6303e5f81a2a982a6915a";

export default node;
